angular.module('elogbooksFilters').filter('implodeList', function(lodash) {
    return function(list) {
        var string = '';
        lodash.each(list, function (element) {
            string += element.name + ', ';
        });
        return string.substring(0, string.length - 2);
    };
});
